'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createElement = createElement;
function createElement(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}

exports.default = {
    createElement: createElement
};



//////////////////
// WEBPACK FOOTER
// ./~/marks-pane/lib/svg.js
// module id = 1564
// module chunks = 0